import React, { useState } from 'react';
import { Stack, Typography, Button, useMediaQuery } from '@mui/material';
import { NavLink } from 'react-router-dom';
import Category from './Category';
import Category2 from './Category2';
import Category1 from './Category1'; // Add Category3 component
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/autoplay';
import { Navigation, Autoplay } from 'swiper/modules';

function Categories() {
    const [filter, setFilter] = useState("all");
    const isMobile = useMediaQuery('(max-width:768px)');

    const filters = [
        { key: "all", label: "الكل" },
        { key: "somebuild", label: "إعادة بناء جزئية" },
        { key: "allbuild", label: "إعادة بناء كاملة" },
        { key: "electric", label: "إصلاحيات كهربائية" },
        { key: "plumb", label: "إصلاحيات سباكية" },
        { key: "materials", label: "دعم بالمواد" },
        { key: "athath", label: "دعم بالأثاث" }
    ];

    return (
        <Stack alignItems="center" sx={{ py: 6, backgroundColor: "#f9f9f9" }}>
            <Typography variant={isMobile ? "h5" : "h4"} sx={{ fontWeight: "bold", mb: 3, color: "#333" }}>
                شركاؤنا في التأثير
            </Typography>

            <Stack
                direction="row"
                alignItems="center"
                justifyContent="center"
                flexWrap="wrap"
                gap={1.5}
                sx={{ mb: 6 }}
            >
                {filters.map(({ key, label }) => (
                    <Typography
                        key={key}
                        onClick={() => setFilter(key)}
                        sx={{
                            cursor: "pointer",
                            padding: "6px 12px",
                            borderRadius: "20px",
                            fontSize: "14px",
                            fontWeight: "bold",
                            transition: "0.3s",
                            backgroundColor: filter === key ? "#15513c" : "transparent",
                            color: filter === key ? "#fff" : "#15513c",
                            border: "1px solid #15513c",
                            "&:hover": {
                                backgroundColor: "#15513c",
                                color: "#fff"
                            }
                        }}
                    >
                        {label}
                    </Typography>
                ))}
            </Stack>

            <Stack sx={{ width: "90%", maxWidth: "1200px", pb: 4, position: "relative" }}>
                <Swiper
                    slidesPerView={isMobile ? 1 : 3}
                    spaceBetween={isMobile ? 120 : 15}
                    navigation
                    autoplay={{
                        delay: 3000,
                        disableOnInteraction: false
                    }}
                    loop={true}
                    breakpoints={{
                        320: { slidesPerView: 1, spaceBetween: 30 },
                        600: { slidesPerView: 2, spaceBetween: 120 },
                        900: { slidesPerView: 3, spaceBetween: 30 }
                    }}
                    className="mySwiper"
                    modules={[Navigation, Autoplay]}
                >
                    {/* Render 3 different categories */}
                    
                    <SwiperSlide>
                        <Category1 />
                    </SwiperSlide>
                    <SwiperSlide>
                        <Category2 />
                    </SwiperSlide>
                    <SwiperSlide>
                        <Category />
                    </SwiperSlide>
                    <SwiperSlide>
                        <Category1 />
                    </SwiperSlide>
                    <SwiperSlide>
                        <Category2 />
                    </SwiperSlide>
                    <SwiperSlide>
                        <Category />
                    </SwiperSlide>
                </Swiper>
            </Stack>

            <NavLink to="/seeOther" style={{ textDecoration: "none" }}>
                <Button
                    variant="contained"
                    sx={{
                        backgroundColor: "#15513c",
                        color: "#fff",
                        padding: "10px 24px",
                        fontSize: "16px",
                        fontWeight: "bold",
                        borderRadius: "25px",
                        transition: "0.3s",
                        "&:hover": {
                            backgroundColor: "#0f3d2a"
                        }
                    }}
                >
                    مشاهدة المزيد
                </Button>
            </NavLink>
        </Stack>
    );
}

export default Categories;
